import React, { useState, useEffect } from 'react';
import { thumb, message } from 'assets/images';

const Articles = () => {
	const [articles, setArticles] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const postsPerPage = 4;

	// Fetch articles from backend
	useEffect(() => {
		fetch('http://localhost:5000/api/articles')
			.then((response) => response.json())
			.then((data) => {
				console.log('Fetched data:', data); // Debugging: Check backend response
				setArticles(Array.isArray(data.data) ? data.data : []); // Extract article array safely
			})
			.catch((error) => console.error('Error fetching articles:', error));
	}, []);

	// Get current posts
	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts = articles.slice(indexOfFirstPost, indexOfLastPost); // Use articles instead of ArticleData
	const npage = Math.ceil(articles.length / postsPerPage); // Use articles.length
	const numbers = [...Array(npage + 1).keys()].slice(1);

	function changeCPage(id) {
		setCurrentPage(id);
	}

	return (
		<>
			<div>
				{currentPosts.map((article, id) => (
					<div key={id} className='mt-10'>
						<div className='border-2 border-purple border-solid'>
							<h1 className='text-transparent font-semibold bg-clip-text bg-gradient-to-b from-purple to-gold text-xl px-4 md:px-4 lg:px-10 xl:px-10 2xl:px-10 pt-10'>
								{article.topic}
							</h1>
							<p className='text-grey text-base px-4 md:px-4 lg:px-10 xl:px-10 2xl:px-10'>
								{article.date}
							</p>
							<p className='text-sm text-justify py-6 px-4 md:px-4 lg:px-10 xl:px-10 2xl:px-10'>
								{article.article}
							</p>
							<p className='text-transparent font-semibold bg-clip-text bg-gradient-to-b from-purple to-gold text-base px-4 md:px-4 lg:px-10 xl:px-10 2xl:px-10 pb-6'>
								{article.fullName}
							</p>
							<div className='flex justify-center gap-x-2 px-0'>
								<button className='py-4 text-base bg-black text-white mt-4 w-full flex justify-center gap-x-4 items-center'>
									<img src={thumb} alt='thumb' width={20} />
									Like
								</button>
								<button className='py-4 text-base bg-black text-white mt-4 w-full flex justify-center gap-x-4 items-center'>
									<img src={message} alt='message' width={20} />
									Comment
								</button>
							</div>
						</div>
					</div>
				))}
			</div>

			{/* Pagination Section */}
			<div className='grid grid-cols-3 text-sm mt-6'>
				<div></div>
				<div className='flex items-center font-medium gap-x-2'>
					{numbers.map((n, i) => (
						<a
							key={i}
							onClick={() => changeCPage(n)}
							href='#'
							className={`page-item ${
								currentPage === n ? 'active' : ''
							} border-solid border-[#000] border-2 px-6 py-2`}
						>
							{n}
						</a>
					))}
				</div>
				<div></div>
			</div>
		</>
	);
};

export default Articles;
